var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table-data-row"},_vm._l((_vm.columns),function(column){return _c('td',{key:column.value},[_vm._v(" "+_vm._s(_vm.cellData(column.value))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }